import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { FormatDate } from '../../../../../../constants';
import { getStateDescription } from '../../../../../shared/utils';
import { FilePickerCaseListTabKey } from './file-picker-case-list';
interface FilePickerArchivedCaseListProps {
  cases: any[];
  setCaseInfo: (selectedCaseId: string, selectedCaseType: string, selectedIsArchived?: boolean) => void;
  applicantName: string;
  selectedTab: string;
}

export const FilePickerArchivedCaseList: React.FC<FilePickerArchivedCaseListProps> = ({ cases, setCaseInfo, applicantName, selectedTab }) => {
  const [selectedCaseId, setSelectedCaseId] = useState<string>('');

  const handleClick = (id: string, caseType: string) => {
    setSelectedCaseId(id);
    setCaseInfo(id, caseType, true);
    console.log('selectedCaseId', selectedCaseId);
  };

  useEffect(() => {
    // Reset selected case info when switching to Active tab to clear the selection and document file list
    if (selectedTab === FilePickerCaseListTabKey.ACTIVE) {
      setSelectedCaseId('');
      setCaseInfo('', '', true);
    }
  }, [selectedTab]);

  const columns = [
    {
      title: '',
      dataIndex: 'cases',
      key: 'cases',
      render: (text: any, record: any) => (
        <button
          id={text}
          onClick={() => handleClick(record.id, record.caseType)}
          onKeyDown={() => {}}
          tabIndex={0}
          style={{
            display: 'block',
            border: '1px solid black',
            margin: '10px',
            padding: '10px',
            backgroundColor: selectedCaseId === record.id ? '#EAECFA' : '#f5f5f5',
            cursor: 'pointer',
            textAlign: 'left',
            outline: 'none',
            borderRadius: '4px',
            boxShadow: selectedCaseId === record.id ? '0 0 10px rgba(0,0,0,0.2)' : 'none',
            minWidth: '200px'
          }}
        >
          <div>{record.caseName}</div>
          <div style={{ textAlign: 'center', fontWeight: 'bold' }}>{applicantName}</div>
          <div
            style={{
              border: '1px solid black',
              textAlign: 'center',
              backgroundColor: record.state === 'submitted' ? '#d4edda' : '#ffe4b5',
              margin: '3px'
            }}
          >
            {getStateDescription(record.state)}
          </div>
          <div>Date Archived:</div>
          <div>{FormatDate(record.archivedAt)}</div>
        </button>
      )
    }
  ];

  return (
    <Table
      dataSource={cases}
      columns={columns}
      rowKey="id"
      pagination={{ pageSize: 3 }}
      style={{
        backgroundColor: 'white'
      }}
      showHeader={false}
    />
  );
};
